import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.promise.finally.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import i18n from 'i18next';
import config from 'utils/config';
import { fetchMindsetSettings } from 'actions/userProfile/useFetchUserMindsetAgent';
import createElement from 'tricks/dom/createElement';
import { getDarkerColorShadeHex } from '../ui';
import { renderMindsetSDK2 } from './renderMindsetSDK2';
import { renderMindsetSDK3 } from './renderMindsetSDK3';
// ID of the container where the Mindset SDK will be rendered
export var MINDSET_ID = 'mindset-container';
// ID of the container for the floating panel agent
export var MINDSET_FLOATING_ID = 'mindset-floating-container';
// ID of the container for the persistent sidebar agent
export var MINDSET_SIDEBAR_ID = 'mindset-sidebar-container';
export function getAgentElement(containerId) {
  var _document$getElementB;
  return (_document$getElementB = document.getElementById(containerId)) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.querySelector('mindset-agent');
}
export var MINDSET_OPEN_WITH_MESSAGE_EVENT = 'mindset:open-with-message';
// Buffers a message dispatched before any listener has registered (e.g. on a
// cold page load where the sidebar hasn't mounted yet). The listener consumes
// it when it first registers via useOpenMindsetWithMessageEvent.
var pendingOpenMessage = null;
export function consumePendingOpenMessage() {
  var msg = pendingOpenMessage;
  pendingOpenMessage = null;
  return msg;
}
export function openMindsetAgentWithMessage(message, options) {
  var _options$silent, _options$threadTitle, _options$coachingCont;
  var detail = {
    message: message,
    silent: (_options$silent = options === null || options === void 0 ? void 0 : options.silent) !== null && _options$silent !== void 0 ? _options$silent : false,
    threadTitle: (_options$threadTitle = options === null || options === void 0 ? void 0 : options.threadTitle) !== null && _options$threadTitle !== void 0 ? _options$threadTitle : '',
    coachingContext: (_options$coachingCont = options === null || options === void 0 ? void 0 : options.coachingContext) !== null && _options$coachingCont !== void 0 ? _options$coachingCont : ''
  };
  pendingOpenMessage = detail;
  window.dispatchEvent(new CustomEvent(MINDSET_OPEN_WITH_MESSAGE_EVENT, {
    detail: detail
  }));
}
export function openMindsetCoachingPanel(_ref) {
  var skillName = _ref.skillName,
    coachingContext = _ref.coachingContext;
  openMindsetAgentWithMessage(i18n.t('coach_ai_thread_prompt_coaching', {
    skillName: skillName
  }), {
    threadTitle: skillName ? i18n.t('coach_ai_thread_title_coaching', {
      skillName: skillName
    }) : '',
    coachingContext: coachingContext
  });
}
var MINDSET_SERVER_URL = 'https://mindset-prod2-eu-embedded-sdk-v3.web.app';
export var MINDSET_SDK3_URL = "".concat(MINDSET_SERVER_URL, "/mindset-sdk3.umd.js");
export var MINDSET_SDK2_URL = "https://mindset-prod2-eu-embedded-sdk.web.app/mindset-sdk2.js";
export function buildMindsetTheme(theme) {
  var cardTheme = theme.sections.card;
  var errorColor = theme.globals.colorBlocks.negative;
  var primaryButtonColor = theme.globals.buttons.primary;
  var defaultButtonColor = theme.globals.buttons.default;
  var importantButtonColor = theme.globals.buttons.important;
  var mindsetPrimaryText = theme.globals.colorBlocks.mindset;
  var mindsetPrimaryRawBg = theme.globals.colorBlocks['mindset-background'];
  var mindsetPrimaryBg = mindsetPrimaryRawBg === cardTheme.background ? getDarkerColorShadeHex(mindsetPrimaryRawBg) : mindsetPrimaryRawBg;
  var cardBgDarker = getDarkerColorShadeHex(cardTheme.background);
  return {
    brightness: 'light',
    surfaceTint: null,
    primary: mindsetPrimaryText,
    onPrimary: mindsetPrimaryBg,
    primaryContainer: mindsetPrimaryBg,
    onPrimaryContainer: mindsetPrimaryText,
    secondary: defaultButtonColor.text,
    onSecondary: defaultButtonColor.background,
    secondaryContainer: defaultButtonColor.text,
    onSecondaryContainer: defaultButtonColor.background,
    tertiary: importantButtonColor.text,
    onTertiary: importantButtonColor.background,
    tertiaryContainer: importantButtonColor.text,
    onTertiaryContainer: importantButtonColor.background,
    error: errorColor,
    onError: cardTheme.text,
    errorContainer: cardTheme.text,
    onErrorContainer: errorColor,
    background: cardTheme.background,
    onBackground: cardTheme.text,
    surface: cardTheme.background,
    onSurface: cardTheme.text,
    surfaceVariant: cardTheme.background,
    onSurfaceVariant: cardTheme.text,
    outline: cardTheme.text,
    outlineVariant: cardTheme.text,
    shadow: cardTheme.shade,
    scrim: '#000000',
    inverseSurface: cardTheme.text,
    inverseOnSurface: cardTheme.background,
    inversePrimary: primaryButtonColor.text,
    primaryFixed: primaryButtonColor.background,
    onPrimaryFixed: primaryButtonColor.text,
    primaryFixedDim: getDarkerColorShadeHex(primaryButtonColor.background),
    onPrimaryFixedVariant: primaryButtonColor.text,
    secondaryFixed: defaultButtonColor.background,
    onSecondaryFixed: defaultButtonColor.text,
    secondaryFixedDim: getDarkerColorShadeHex(defaultButtonColor.background),
    onSecondaryFixedVariant: defaultButtonColor.text,
    tertiaryFixed: importantButtonColor.background,
    onTertiaryFixed: importantButtonColor.text,
    tertiaryFixedDim: getDarkerColorShadeHex(importantButtonColor.background),
    onTertiaryFixedVariant: importantButtonColor.text,
    surfaceDim: cardBgDarker,
    surfaceBright: getDarkerColorShadeHex(cardTheme.background, 0.01),
    surfaceContainerLowest: cardBgDarker,
    surfaceContainerLow: cardBgDarker,
    surfaceContainer: cardBgDarker,
    surfaceContainerHigh: cardBgDarker,
    surfaceContainerHighest: cardBgDarker
  };
}
function domPrefetchScript(scriptURL) {
  // Prefetch the scriptURL for future navigation, if it hasn't been prefetched yet
  var prefetchedScript = document.querySelector("link[rel=prefetch][href=\"".concat(scriptURL, "\"]"));
  if (!prefetchedScript) {
    var newLink = createElement('link', {
      rel: 'prefetch',
      href: scriptURL,
      as: 'script'
    });
    document.head.appendChild(newLink);
  }
}
export function addMindsetAIIfRequired() {
  return _addMindsetAIIfRequired.apply(this, arguments);
}
function _addMindsetAIIfRequired() {
  _addMindsetAIIfRequired = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _ref2,
      _ref2$render,
      render,
      _ref2$search,
      initialQuestion,
      forceTrialOnboardingPlan,
      appUid,
      hasMindsetSDK2,
      _yield$fetchMindsetSe,
      agentUid,
      scriptURL,
      _args = arguments;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref2 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, _ref2$render = _ref2.render, render = _ref2$render === void 0 ? false : _ref2$render, _ref2$search = _ref2.search, initialQuestion = _ref2$search === void 0 ? '' : _ref2$search, forceTrialOnboardingPlan = _ref2.forceTrialOnboardingPlan;
          appUid = config.mindsetAppUid, hasMindsetSDK2 = config.hasMindsetSDK2;
          if (appUid) {
            _context.next = 1;
            break;
          }
          return _context.abrupt("return");
        case 1:
          _context.next = 2;
          return fetchMindsetSettings({
            forceTrialOnboardingPlan: forceTrialOnboardingPlan
          });
        case 2:
          _yield$fetchMindsetSe = _context.sent;
          agentUid = _yield$fetchMindsetSe.agentUid;
          if (agentUid) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return");
        case 3:
          if (!hasMindsetSDK2) {
            _context.next = 6;
            break;
          }
          scriptURL = MINDSET_SDK2_URL;
          if (render) {
            _context.next = 4;
            break;
          }
          domPrefetchScript(scriptURL);
          return _context.abrupt("return");
        case 4:
          _context.next = 5;
          return renderMindsetSDK2({
            scriptURL: scriptURL,
            appUid: appUid,
            initialQuestion: initialQuestion,
            agentUid: agentUid
          });
        case 5:
          _context.next = 8;
          break;
        case 6:
          if (render) {
            _context.next = 7;
            break;
          }
          domPrefetchScript(MINDSET_SDK3_URL);
          return _context.abrupt("return");
        case 7:
          _context.next = 8;
          return renderMindsetSDK3({
            appUid: appUid,
            initialQuestion: initialQuestion,
            agentUid: agentUid
          });
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _addMindsetAIIfRequired.apply(this, arguments);
}
function addMindsetSDK3AgentIfRequired(_x) {
  return _addMindsetSDK3AgentIfRequired.apply(this, arguments);
}
function _addMindsetSDK3AgentIfRequired() {
  _addMindsetSDK3AgentIfRequired = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(containerId) {
    var initialQuestion,
      appUid,
      _yield$fetchMindsetSe2,
      agentUid,
      _args2 = arguments;
    return _regeneratorRuntime.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          initialQuestion = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : '';
          appUid = config.mindsetAppUid;
          if (appUid) {
            _context2.next = 1;
            break;
          }
          return _context2.abrupt("return");
        case 1:
          _context2.next = 2;
          return fetchMindsetSettings();
        case 2:
          _yield$fetchMindsetSe2 = _context2.sent;
          agentUid = _yield$fetchMindsetSe2.agentUid;
          if (agentUid) {
            _context2.next = 3;
            break;
          }
          return _context2.abrupt("return");
        case 3:
          _context2.next = 4;
          return renderMindsetSDK3({
            appUid: appUid,
            agentUid: agentUid,
            initialQuestion: initialQuestion,
            containerId: containerId,
            agentHeight: '100%'
          });
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _addMindsetSDK3AgentIfRequired.apply(this, arguments);
}
export function addMindsetFloatingIfRequired() {
  return _addMindsetFloatingIfRequired.apply(this, arguments);
}

// Deduplicate concurrent init calls: the initialization useEffect and handleOpen
// (triggered by the pending-message buffer) can both call this simultaneously.
// Without deduplication, renderMindsetSDK3 runs twice — the second call removes
// the mindset-agent element the first call appended, losing the message.
function _addMindsetFloatingIfRequired() {
  _addMindsetFloatingIfRequired = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var initialQuestion,
      _args3 = arguments;
    return _regeneratorRuntime.wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          initialQuestion = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : '';
          return _context3.abrupt("return", addMindsetSDK3AgentIfRequired(MINDSET_FLOATING_ID, initialQuestion));
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _addMindsetFloatingIfRequired.apply(this, arguments);
}
var sidebarInitInFlight = null;
export function addMindsetSidebarIfRequired() {
  return _addMindsetSidebarIfRequired.apply(this, arguments);
}
function _addMindsetSidebarIfRequired() {
  _addMindsetSidebarIfRequired = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var initialQuestion,
      _args4 = arguments;
    return _regeneratorRuntime.wrap(function (_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          initialQuestion = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : '';
          if (!sidebarInitInFlight) {
            sidebarInitInFlight = addMindsetSDK3AgentIfRequired(MINDSET_SIDEBAR_ID, initialQuestion).finally(function () {
              sidebarInitInFlight = null;
            });
          }
          return _context4.abrupt("return", sidebarInitInFlight);
        case 1:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _addMindsetSidebarIfRequired.apply(this, arguments);
}